// extracted by mini-css-extract-plugin
export var footer = "_og-5";
export var fulfillmentInput = "_og-0";
export var shipDateInput = "_og-1";
export var shipmentModal = "_og-2";
export var shipmentModalContent = "_og-3";
export var tableContainer = "_og-4";